import abi from './Voting.json'

export const VOTING_ABI = abi.abi;
export const VOTING_ADDRESS = '0x7Db7Fb35D946799D7FCd40A3fb67F071FD36a914';